module.exports = __webpack_public_path__ + "assets/images/vcr_restaurant-03.fc452622c3975d38762b4c7b49f94a0c.svg";